//console.log("Custom JavaScript file loaded");


try {
    // Add your custom JS here.

    /*
     * Toggle Detail Accordions on anchor navigation
     *
     * Reference: https://stackoverflow.com/questions/37033406/automatically-open-details-element-on-id-call
     */
    function openTarget() {
        const hash = location.hash.substring(1);
        if (hash) {
            const target = document.getElementById(hash);
            if (target) {
                var details = ';'
                if (target.tagName.toLowerCase() === 'details') {
                    details = target;
                } else {
                    details = target.querySelector("details");
                }
                if (details && details.tagName.toLowerCase() === 'details') {
                    // opens the target if it is a details element or the target's first child detail element
                    details.open = true;
                }
            }
        }
    }
    openTarget(); // onload
    window.addEventListener('hashchange', openTarget);




    /*
     * Toggle Footer Accordions and desktop dropdown links
     */

    /*function toggleMobileEvents() {
        const footer_accordions = document.querySelectorAll("footer .widget_nav_menu:not(:has(.menu-social-container)) > div > .menu > .menu-item-has-children > a");
        const mediaQuery = window.matchMedia('(max-width: 767px)');
        if (mediaQuery.matches) {
            // Code to execute if the media query matches (e.g., screen width is less than or equal to 768px)
            for (let i = 0; i < footer_accordions.length; i++) {
                footer_accordions[i].onclick = function(e) {
                    e.preventDefault();
                    this.parentNode.classList.toggle("toggled");
                }
            }
        } else {
            // Code to execute if the media query does not match
            for (let i = 0; i < footer_accordions.length; i++) {
                footer_accordions[i].onclick = function(e) {
                    e.preventDefault(); // Don't do whatever bootstrap or understrap is trying to do
                    const anchor = e.target.closest("a"); // Find closest Anchor (or self)
                    if (!anchor) return; // Not found. Exit here.
                    window.location.assign(anchor.getAttribute('href')); // Navigate as expected

                }
            }

        }
    }
    toggleMobileEvents();

    window.addEventListener('resize', toggleMobileEvents);*/

    // Enable drop down menu clicking on desktop only. 
    document.querySelectorAll(".dropdown-toggle").forEach(function(dropdown) {

        dropdown.addEventListener("click", function(event) {

            const mediaQuery = window.matchMedia('(max-width: 767px)');
            if (mediaQuery.matches) {
                event.preventDefault();
                // console.log('click match query');

            } else {
                //console.log('click');
                event.preventDefault(); // Don't do whatever bootstrap or understrap is trying to do
                const anchor = event.target.closest("a"); // Find closest Anchor (or self)
                if (!anchor) return; // Not found. Exit here.
                anchor.setAttribute("aria-expanded", false); // Keep menu closed if user uses back navigation in browser

                const next = anchor.parentElement.getElementsByClassName("dropdown-menu")[0]; // Select dropdown ul
                next.classList.remove("show"); // Keep menu closed if user uses back navigation in browser 
                anchor.classList.remove('show'); // Keep menu closed if user uses back navigation in browser
                window.location.assign(anchor.getAttribute('href')); // Navigate as expected



            }
        });
    });
    document.querySelectorAll(".dropdown-menu .dropdown-item, .nav-link:not(.dropdown-toggle").forEach(function(navlink) {
        navlink.addEventListener("click", function(event) {
            const mediaQuery = window.matchMedia('(max-width: 767px)');

            if (mediaQuery.matches) {
                // Close the menu

                document.getElementsByClassName('navbar-toggler')[0].click();

            }
        });
    });


    /*
     * Swiper
     * 
     * Reference: https://swiperjs.com/
     *            https://swiperjs.com/demos
     *            https://wordpress.org/plugins/wp-swiper/
     *            https://digitalapps.com/wordpress-plugins/wp-swiper/
     *            https://github.com/nolimits4web/swiper/
     */
   
    var newsSwiper = new Swiper(".myNewsSwiper", {
        slidesPerView: 2,
        lazyPreloadPrevNext: 1,
        spaceBetween: 32,
        centeredSlides: false,
        lazy: true,
        keyboard: {
            enabled: true,
        },
        mousewheel: false,
        grabCursor: true,
        /*navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },*/
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
                lazyPreloadPrevNext: 1,
            },
            1200: {
                slidesPerView: 3,
                lazyPreloadPrevNext: 1,
            },
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        on: {
            slideChange: function() {

                if (typeof newsDetailChange === 'function') {
                    newsDetailChange(newsSwiper.activeIndex);
                } else {
                    console.error("newsDetailChange is not defined");
                }
            },
        },
    });
    var newsSwiper2 = new Swiper(".myNewsSwiper2", {
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 0,
        allowTouchMove: false,
        keyboard: {
            enabled: false,
        },
        mousewheel: false,
        grabCursor: false,
        preventClicks: false,
        preventClicksPropagation: false,
        effect: "fade",

    });
    var projectsSwiper = new Swiper(".myProjectsSwiper", {
        slidesPerView: 1,
        lazyPreloadPrevNext: 1,
        spaceBetween: 0,
        centeredSlides: false,
        lazy: true,
        allowTouchMove: false,
        keyboard: {
            enabled: false,
        },
        mousewheel: false,
        grabCursor: false,
        preventClicks: false,
        preventClicksPropagation: false,
        loop: true,
        effect: "fade",
        navigation: {
            nextEl: ".swiper-button-next",
        },

    });
    var aboutSwiper = new Swiper(".myAboutSwiper", {
        slidesPerView: 1,
        lazyPreloadPrevNext: 2,
        spaceBetween: 8,
        centeredSlides: false,
        lazy: true,
        keyboard: {
            enabled: true,
        },
        mousewheel: false,
        grabCursor: true,
        navigation: {
            nextEl: ".swiper-button-next",
            //prevEl: ".swiper-button-prev",
        },

    });
    var timelineSwiper = new Swiper(".myTimelineSwiper", {
        slidesPerView: 1,
        lazyPreloadPrevNext: 1,
        spaceBetween: 0,
        centeredSlides: false,
        lazy: true,
        allowTouchMove: false,
        keyboard: {
            enabled: false,
        },
        mousewheel: false,
        grabCursor: false,
        preventClicks: false,
        preventClicksPropagation: false,
        loop: false,
        effect: "fade",
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        on: {
            slideChange: function() {

                if (typeof rotateToSnapPoint === 'function') {
                    rotateToSnapPoint(timelineSwiper.activeIndex);
                } else {
                    console.error("rotateToSnapPoint is not defined");
                }
            },
        },

    });



    window.newsDetailChange = function(index) {
        const container = document.querySelector('.myNewsSwiper2');
        newsSwiper2.slideTo(index);
        /*
        const children = container.children;
        
        if (index < 0 || index >= children.length) {
            console.error("Invalid index. Must be between 0 and", children.length - 1);
            return;
        }*/




    };




    /*
     * Animate Accordions
     * https://codepen.io/chriscoyier/pen/XWNqxyY
     * https://css-tricks.com/how-to-animate-the-details-element/
     */
    class Accordion {
        constructor(el) {
            // Store the <details> element
            this.el = el;
            // Store the <summary> element
            this.summary = el.querySelector('summary');
            // Store the <div class="content"> element
            this.content = el.querySelector('.details-inner-container');
            this.minHeight = 10;

            // Store the animation object (so we can cancel it if needed)
            this.animation = null;
            // Store if the element is closing
            this.isClosing = false;
            // Store if the element is expanding
            this.isExpanding = false;
            // Detect user clicks on the summary element
            this.summary.addEventListener('click', (e) => this.onClick(e));
        }

        onClick(e) {
            // Stop default behaviour from the browser
            e.preventDefault();
            // Add an overflow on the <details> to avoid content overflowing
            this.el.style.overflow = 'hidden';
            // Check if the element is being closed or is already closed
            if (this.isClosing || !this.el.open) {
                this.open();
                // Check if the element is being openned or is already open
            } else if (this.isExpanding || this.el.open) {
                this.shrink();
            }
        }

        shrink() {
            // Set the element as "being closed"
            this.isClosing = true;

            // Store the current height of the element
            const startHeight = `${this.el.offsetHeight}px`;

            // Calculate the height of the summary
            var endHeight = `${this.summary.offsetHeight}`;
            if (endHeight < this.minHeight) endHeight = this.minHeight;
            endHeight = endHeight + 'px';

            // If there is already an animation running
            if (this.animation) {
                // Cancel the current animation
                this.animation.cancel();
            }

            // Start a WAAPI animation
            this.animation = this.el.animate({
                // Set the keyframes from the startHeight to endHeight
                height: [startHeight, endHeight]
            }, {
                duration: 200,
                easing: 'linear'
            });

            // When the animation is complete, call onAnimationFinish()
            this.animation.onfinish = () => this.onAnimationFinish(false);
            // If the animation is cancelled, isClosing variable is set to false
            this.animation.oncancel = () => this.isClosing = false;
        }

        open() {
            // Apply a fixed height on the element
            this.el.style.height = `${this.el.offsetHeight}px`;
            // Force the [open] attribute on the details element
            this.el.open = true;
            // Wait for the next frame to call the expand function
            window.requestAnimationFrame(() => this.expand());
        }

        expand() {
            // Set the element as "being expanding"
            this.isExpanding = true;
            // Get the current fixed height of the element
            var startHeight = `${this.el.offsetHeight}`;
            if (startHeight < this.minHeight) startHeight = this.minHeight;
            startHeight = startHeight + 'px';
            // Calculate the open height of the element (summary height + content height)
            const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
            // If there is already an animation running
            if (this.animation) {
                // Cancel the current animation
                this.animation.cancel();
            }

            // Start a WAAPI animation
            this.animation = this.el.animate({
                // Set the keyframes from the startHeight to endHeight
                height: [startHeight, endHeight]
            }, {
                duration: 200,
                easing: 'linear'
            });
            // When the animation is complete, call onAnimationFinish()
            this.animation.onfinish = () => this.onAnimationFinish(true);
            // If the animation is cancelled, isExpanding variable is set to false
            this.animation.oncancel = () => this.isExpanding = false;
        }

        onAnimationFinish(open) {
            // Set the open attribute based on the parameter
            this.el.open = open;
            // Clear the stored animation
            this.animation = null;
            // Reset isClosing & isExpanding
            this.isClosing = false;
            this.isExpanding = false;
            // Remove the overflow hidden and the fixed height
            this.el.style.height = this.el.style.overflow = '';
        }
    }

    document.querySelectorAll('details:has(.details-inner-container)').forEach((el) => {
        new Accordion(el);
    });


    /* 
     * Toggle menu/header sticky state based on scroll 
     * Toggle project feed's aside content
     */

    var lastScrollTop = 0;
    window.addEventListener('scroll', function() {
        if (!document.body.classList.contains('home')) {
            // skip if on home page

            // Do menu
            var supportPageOffset = window.pageXOffset !== undefined;
            var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
            var scrollTop = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
            var mainNav = document.getElementById("main-nav");
            var scrollPosModifier = .8; // 80% of the viewport height

            if (scrollTop > lastScrollTop) {
                // downscroll code
                if (scrollTop < (window.innerHeight * scrollPosModifier)) {
                    mainNav.classList.remove("toggled");
                } else {
                    mainNav.classList.add("toggled");
                }
            } else {
                // upscroll code
                if (scrollTop < (window.innerHeight * scrollPosModifier)) {
                    if (mainNav.classList.contains("toggled")) {
                        mainNav.classList.remove("toggled");
                    }
                }
                if (scrollTop < 1) {
                    mainNav.classList.remove("toggled-out");
                    mainNav.classList.remove("toggled");
                }
            }
            lastScrollTop = scrollTop;

            //Do asides if media query matches medium or larger screens
            const mediaQuery = window.matchMedia('(min-width: 768px)');
            if (mediaQuery.matches) {
                // Screen is at or beyond the md breakpoint

                // Get all asides
                var asides = document.querySelectorAll(".aside-section-container");

                // Asign variables
                //const spacer = 32;
                const spacer = 56;
                const stickyMenuHeight = 100;

                // Get the top position of the footer
                const theFooter = document.getElementById("colophon");
                const footerTop = theFooter.getBoundingClientRect().top;

                // Find the top offset, which changes if the sticky menu is toggled or not OR if on the home page
                var topOffset = mainNav.classList.contains("toggled") ? (stickyMenuHeight + spacer) : spacer;

                // Do loop
                asides.forEach(function(aside, index) {

                    // Get this aside's top position in relation to the screen
                    const asideTop = aside.getBoundingClientRect().top;

                    // Get the styles of this aside (technically the child div since that is how the aside is 'fixed' positioned)
                    const thisStyles = window.getComputedStyle(aside.firstChild)

                    // Get the top CSS top position of this aside. 
                    const thisTop = parseInt(thisStyles.getPropertyValue('top'));

                    // Get this width of this aside
                    const thisWidth = aside.firstChild.getBoundingClientRect().height;

                    // Toggle the aside if scrolled past the offset position
                    if (asideTop <= topOffset) {
                        if (!aside.classList.contains('toggled')) {
                            aside.classList.add('toggled');
                        }
                    } else {
                        if (aside.classList.contains('toggled')) {
                            aside.classList.remove('toggled');
                        }
                    }

                    // Check if there's more than one aside on the screen and if so, allow them to interact with each other
                    if (index < asides.length - 1) {
                        // More than one aside found

                 
                        // Get the next aside element
                        const nextElement = asides[index + 1];
                        // Get the top position of the next element in relation to the viewport
                        const nextTop = nextElement.getBoundingClientRect().top;


                        // Adjust CSS top of this aside 
                        if ((topOffset + thisWidth + spacer) < nextTop) {
                            // Asides are NOT colliding, so make sure CSS top is the default offset value. 
                            // This needs to be done to correctly position the aside once the user scrolls up far enough
                            aside.firstChild.style.top = topOffset + 'px';
                        } else {
                            // Asides are colliding, so move this aside up

                            // Get overlap value as a negative number
                            const overlap = nextTop - (thisWidth + thisTop + spacer);

                            // Find new top position by applying the overlap to the original top value 
                            const newTop = thisTop + overlap;

                            //console.log('newTop: ' + newTop);

                            // Apply the new styles
                            aside.firstChild.style.top = newTop + 'px';
                        }

                    
                    }

                    // Check if the footer is colliding with the aside

                    if (aside.classList.contains('toggled')) {
                        if ((topOffset + thisWidth + spacer) >= footerTop) {
                            
                            aside.firstChild.style.opacity = 0;
                        } else {
                          
                            aside.firstChild.style.opacity = 1;
                        }
                    }



                });




            }




        }
    });




    /*
     * Modal windows for Videos and Sort Forms
     * 
     * Reference: https://www.w3schools.com/howto/howto_css_modals.asp
     *            https://www.w3schools.com/tags/tryit.asp?filename=tryhtml5_global_data
     */


    const modal_btns = document.getElementsByClassName("ev-modal-btn");

    for (let i = 0; i < modal_btns.length; i++) {
        var this_modal_btn = modal_btns[i];
        var this_modal_id = this_modal_btn.getAttribute("data-modal-target");
        if (this_modal_id) {
            this_modal_btn.onclick = function(e) {
                e.preventDefault();
                var this_modal_id = this.getAttribute("data-modal-target");


                var this_modal = document.getElementById(this_modal_id);
                if (this_modal) {
                    var span = this_modal.getElementsByClassName("ev-modal-close")[0];
                    if (span) {
                        span.onclick = function() {
                            this_modal.style.display = "none";
                            const iframe = this_modal.querySelector('iframe');
                            if (iframe) {
                                const src = iframe.getAttribute('src');
                                console.log(src);
                                iframe.src = ''; // Remove the iframe source
                                setTimeout(() => {
                                    iframe.src = src; // Reapply the iframe source after a short delay
                                }, 50); // Delay to ensure proper reload
                                
                            }
                        }
                    }
                    this_modal.style.display = "block";
                }

            }


        } //if (this_modal_id) {

    } //for (let i = 0; i < modal_btns.length; i++) {

    /* 
     // When the user clicks anywhere outside of the modals, close it
     window.onclick = function(event) {
        
         var modals = document.getElementsByClassName("ev-modal");
         
         for (let i = 0; i < modals.length; i++) {
             if (event.target == modals[i]) {
                 modals[i].style.display = "none";
             }
         }

     }*/

    // Move Modals to body
    var modals = document.getElementsByClassName("ev-modal");
    for (let i = 0; i < modals.length; i++) {

        document.body.appendChild(modals[0]);
        // always append [0] since it is removed from the array each time (what was [1] becomes [0])

    }




    // Check if URL has GET parameters for "project_categories" or "project_values"
    if (document.body.classList.contains('page-id-40')) {
        // only run on projects page (id 40)
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('project_categories') ||
            urlParams.has('project_values') ||
            urlParams.has('categories') ||
            urlParams.has('tags') ||
            urlParams.has('c') ||
            urlParams.has('v') ||
            urlParams.has('t')) {
            // Scroll to the element with ID "projects"
            const sortElement = document.getElementById('projects');
            if (sortElement) {
                sortElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        }
    }


    /*
     * Do JS code for timeline on the about page
     *
     * Adds a date to a circle/wheel for every item in the Timeline Swiper Slider
     * Allows the user to click and drag the wheel to rotate it. Snaps to points and applies appropriate styles to each date/point
     * Changes the Timeline Swiper Slider to the appropriate slide when the user spins the wheel
     * The timeline itself also spins the wheel on slide change via on onChange event when the slider is initialized
     */

    if (document.querySelector('.wp-block-timeline')) {
        /*
         * Place timeline wheel events along .timeline-wheel-events-container in a circle 
         */

        const timeline_events = document.getElementsByClassName("timeline-wheel-event");
        const timeline_angle = -360 / timeline_events.length;
        const arrowContainer = document.querySelector('.timeline-circle-arrow-container');

        for (let i = 0; i < timeline_events.length; i++) {
            var this_timeline = timeline_events[i];
            var this_date_el = this_timeline.getElementsByClassName("timeline-wheel-date")[0];
            var this_angle = (i) * timeline_angle;

            this_timeline.style.transform = 'rotate(' + this_angle + 'deg)';
        }

        function updateArrowVisibility(index) {
            if (!arrowContainer) return;

            if (index === 0) {
                //console.log('At start of wheel');
                arrowContainer.classList.add('hide-after');
                arrowContainer.classList.remove('hide-before');
            } else if (index === timeline_events.length - 1) {
                //console.log('At end of wheel');
                arrowContainer.classList.add('hide-before');
                arrowContainer.classList.remove('hide-after');
            } else {
                //console.log('At middle of wheel');
                arrowContainer.classList.remove('hide-before', 'hide-after');
            }
        }

        window.rotateToSnapPoint = function(index) {
            const container = document.getElementById('timeline-wheel-events-dragger');
            const children = container.children;
            const snapAngle = 360 / children.length;

            if (index < 0 || index >= children.length) {
                console.error("Invalid index. Must be between 0 and", children.length - 1);
                return;
            }

            const rotation = index * snapAngle;

            container.style.transition = 'transform 0.3s ease';
            container.style.transform = `rotate(${rotation}deg)`;
            setTimeout(() => {
                container.style.transition = ''; // Remove transition after animation
            }, 300);

            Array.from(children).forEach((child, childIndex) => {
                if (childIndex === index) {
                    child.classList.add('toggled');
                    timelineSwiper.slideTo(index);
                } else {
                    child.classList.remove('toggled');
                }
            });

            updateArrowVisibility(index);
        };

        /*
         * Enable dragging and touch controls for #timeline-wheel-events-container
         */

        (function enableTimelineWheelDragWithLimits() {
            const container = document.getElementById('timeline-wheel-events-dragger');
            const children = container.children;
            const snapAngle = 360 / children.length;
            const maxRotation = (children.length - 1) * snapAngle; // Maximum rotation limit
            const minRotation = 0; // Minimum rotation limit
            let isDragging = false;
            let startX, startY, startRotation, lastDelta = 0,
                velocity = 0,
                animationFrame;

            function getRotation(transform) {
                const match = transform.match(/rotate\(([-\d.]+)deg\)/);
                return match ? parseFloat(match[1]) : 0;
            }

            function snapToClosestAngle(rotation) {
                return Math.round(rotation / snapAngle) * snapAngle;
            }

            function animateSnapTo(rotation) {
                container.style.transition = 'transform 0.3s ease';
                container.style.transform = `rotate(${rotation}deg)`;
                setTimeout(() => {
                    container.style.transition = ''; // Remove transition after animation
                }, 300);

                const snappedIndex = (Math.round(-rotation / snapAngle) % children.length + children.length) % children.length;
                Array.from(children).forEach((child, index) => {
                    if (index === (children.length - snappedIndex) % children.length) {
                        child.classList.add('toggled');
                        timelineSwiper.slideTo(index);
                    } else {
                        child.classList.remove('toggled');
                    }
                });

                //updateArrowVisibility(snappedIndex); // removed to prevent duplicate and incorrect adjustments to the arrows
            }

            function onDragStart(event) {
                isDragging = true;
                startX = event.type === 'touchstart' ? event.touches[0].clientX : event.clientX;
                startY = event.type === 'touchstart' ? event.touches[0].clientY : event.clientY;
                startRotation = getRotation(container.style.transform || '');
                lastDelta = 0;
                velocity = 0;
                cancelAnimationFrame(animationFrame);
                event.preventDefault();
            }

            function onDragMove(event) {
                if (!isDragging) return;
                const currentX = event.type === 'touchmove' ? event.touches[0].clientX : event.clientX;
                const currentY = event.type === 'touchmove' ? event.touches[0].clientY : event.clientY;
                const deltaX = currentX - startX;
                const deltaY = currentY - startY;
                const delta = (deltaY - deltaX) / 6; // Slow down the rotation by dividing the delta
                velocity = delta - lastDelta; // Calculate velocity
                lastDelta = delta;

                let newRotation = startRotation + delta;

                // Apply rotation limits
                if (newRotation > maxRotation) {
                    newRotation = maxRotation;
                } else if (newRotation < minRotation) {
                    newRotation = minRotation;
                }

                container.style.transform = `rotate(${newRotation}deg)`;
            }

            function onDragEnd() {
                if (!isDragging) return;
                isDragging = false;
                const currentRotation = getRotation(container.style.transform || '');
                applyInertia(currentRotation, velocity);
            }

            function applyInertia(rotation, velocity) {
                const friction = 0.9; // Friction factor to slow down the spin
                const threshold = 0.1; // Minimum velocity to stop the spin

                function step() {
                    velocity *= friction;
                    rotation += velocity;

                    // Apply rotation limits
                    if (rotation > maxRotation) {
                        rotation = maxRotation;
                        velocity = 0;
                    } else if (rotation < minRotation) {
                        rotation = minRotation;
                        velocity = 0;
                    }

                    container.style.transform = `rotate(${rotation}deg)`;

                    if (Math.abs(velocity) > threshold) {
                        animationFrame = requestAnimationFrame(step);
                    } else {
                        const snappedRotation = snapToClosestAngle(rotation);
                        animateSnapTo(snappedRotation);
                    }
                }

                step();
            }

            function ensureFirstChildToggled() {
                Array.from(children).forEach((child, index) => {
                    if (index === 0) {
                        child.classList.add('toggled');
                        timelineSwiper.slideTo(index);
                    } else {
                        child.classList.remove('toggled');
                    }
                });

                updateArrowVisibility(0);
            }

            ensureFirstChildToggled();

            container.addEventListener('mousedown', onDragStart);
            container.addEventListener('mousemove', onDragMove);
            container.addEventListener('mouseup', onDragEnd);
            container.addEventListener('mouseleave', onDragEnd);

            container.addEventListener('touchstart', onDragStart);
            container.addEventListener('touchmove', onDragMove);
            container.addEventListener('touchend', onDragEnd);
        })();
    }


} catch (error) {
    console.error("An error occurred in custom-javascript.js:", error);
}